import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { BackgroundContainer } from "../../styles/styles";
import HomeBackgroundImage from "@/assets/home/background.svg";
import GlowEffect from "./GlowEffect";

const BackgroundWrapper = styled.div<{ $showImage: boolean }>`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background-image: ${({ $showImage }) =>
    $showImage ? `url(${HomeBackgroundImage})` : "none"};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 3% center;
`;

interface HomeBackgroundProps {
  showImage?: boolean;
}

const HomeBackground: React.FC<PropsWithChildren<HomeBackgroundProps>> = ({
  children,
  showImage = true,
}) => (
  <BackgroundContainer>
    <BackgroundWrapper $showImage={showImage}>
      <GlowEffect />
    </BackgroundWrapper>
    <div style={{ position: "absolute", inset: 0, zIndex: 2 }}>{children}</div>
    {/* <ScreenSizeIndicator /> */}
  </BackgroundContainer>
);

export default HomeBackground;
